const ineligibleProviders = [
  'WHIRLPOOL COMPANY UK LTD',
  'WHIRLPOOL UK APPLIANCES.',
  'WHIRLPOOL',
  'HOOVER CANDY GROUP',
  'HOOVER CANDY',
].map((i) => i.toLowerCase());

export function isProviderEligible(provider: string): boolean {
  return provider
    ? !ineligibleProviders.includes(provider.toLowerCase())
    : false;
}
